import { Employee } from "@finway-group/shared/lib/models"
import { formatCurrencyNumber } from "@finway-group/shared/lib/utils"
import { TableColumnType, Tag, Tooltip } from "antd"
import { ACTION_COLUMN_WIDTH, AMOUNT_COLUMN_WIDTH, STATUS_COLUMN_WIDTH } from "Components/tables/todoTable.const"
import { TFunction } from "i18next"
import moment from "moment"
import React from "react"
import { PurchaseOrderTodoApprovalButtons } from "../components/PurchaseOrderTodoApprovalButtons"
import { TodoTableNameField } from "../components/TodoTableNameField"
import { PurchaseOrder, State } from "../types/PurchaseOrder.interfaces"

export const enum TodoColumns {
    NAME = "name",
    DESCRIPTION = "description",
    ACTION = "action",
    AMOUNT = "amount",
    STATUS = "state",
}
type GenerateTodoColumnsProps = {
    t: TFunction
    user: Employee
}
export const GeneratePurchaseOrderTodoColumns = ({ t }: GenerateTodoColumnsProps): Array<TableColumnType<PurchaseOrder>> => [
    {
        title: t("purchaseOrders:columns.name"),
        dataIndex: TodoColumns.NAME,
        key: TodoColumns.NAME,
        ellipsis: true,
        width: 370,
        render: (_: unknown, record: PurchaseOrder) => <TodoTableNameField record={record} />,
    },
    {
        title: t("label:description"),
        dataIndex: TodoColumns.DESCRIPTION,
        key: TodoColumns.DESCRIPTION,
        ellipsis: true,
        render: (_: unknown, record: PurchaseOrder) => (
            <Tooltip title={record.description}>
                <div className="text-15 text-[#6B7280]  truncate font-normal w-full">{record.description}</div>
            </Tooltip>
        ),
    },
    {
        title: t("purchaseOrders:columns.action"),
        key: TodoColumns.ACTION,
        width: ACTION_COLUMN_WIDTH,
        render: (_: unknown, record: PurchaseOrder) => <PurchaseOrderTodoApprovalButtons record={record} />,
    },
    {
        title: t("purchaseOrders:columns.status"),
        dataIndex: TodoColumns.STATUS,
        key: TodoColumns.STATUS,
        width: STATUS_COLUMN_WIDTH,
        render: (state: State) => (
            <Tag className="ant-tag-gray" data-testid="finway:purchaseStatusTag:status">
                {t(`enum:PurchaseOrderStateEnum.${state.currentState}`)}
            </Tag>
        ),
    },
    {
        title: t("purchaseOrders:columns.amount"),
        dataIndex: TodoColumns.AMOUNT,
        key: TodoColumns.AMOUNT,
        width: AMOUNT_COLUMN_WIDTH,
        align: "right",
        render: (_: unknown, record: PurchaseOrder) => (
            <div className="flex flex-col gap-4">
                <span className="font-bold text-15">{formatCurrencyNumber({ value: record.totalGrossPrice, currency: record.currency })}</span>
                <span className="text-15 text-[#6B7280] overflow-hidden text-ellipsis whitespace-no-wrap font-normal">{moment(record.dateOfIssue).format("ll")}</span>
            </div>
        ),
    },
]
